import React from 'react';
import PropTypes from 'prop-types';

// --- CORE ---
import { PrintSize, DeliveryOption } from '../prop-types';
import { VIEW_MODE } from '../constants';

// --- COMPONENTS ---
import AddPhotosDevice from '../common/add-photos-device';
import PhotosList from './photos-list';
import LoadingPhotoPlaceholders from './loading-photo-placeholders';
import DebugView from '../common/debug-view';
import { DuplicatePhotosList } from '../common/duplicate-detection/duplicate-photos-list';

export default function MainView({
  ready,
  currentlyLoading,
  currentView,
  hasPhotos,
  // Props for child components
  availableSizes,
  sizesByFinish,
  deliveryOption,
  editingDisabled,
  totalDuplicatesCount,
  photosWithDuplicates,
  addPhotos,
  isSaving,
}) {
  if (!ready) {
    return null;
  }

  if (currentView === VIEW_MODE.DEBUG) {
    return <DebugView />;
  }

  // VIEW_MODE.PHOTOS|DUPLICATES
  if (hasPhotos) {
    if (currentView === VIEW_MODE.PHOTOS) {
      const remainingUploads = currentlyLoading
        ? Number(currentlyLoading.total) - Number(currentlyLoading.index)
        : 0;
      const queueCount = remainingUploads > 1 ? remainingUploads - 1 : 0;

      return (
        <div className="prints-builder__main list-view">
          {currentlyLoading && <LoadingPhotoPlaceholders count={1} />}
          <PhotosList
            availableSizes={availableSizes}
            sizes={sizesByFinish}
            deliveryOption={deliveryOption}
            disabled={editingDisabled}
            trailingContent={
              queueCount > 0 ? (
                <LoadingPhotoPlaceholders count={queueCount} />
              ) : null
            }
          />
        </div>
      );
    }

    return (
      <div className="prints-builder__main">
        <DuplicatePhotosList
          totalDuplicatesCount={totalDuplicatesCount}
          photosWithDuplicates={photosWithDuplicates}
          disabled={editingDisabled}
        />
      </div>
    );
  }

  // No photos - loading or add photos button
  if (currentlyLoading) {
    return (
      <div className="prints-builder__main list-view">
        <LoadingPhotoPlaceholders count={currentlyLoading.total} />
      </div>
    );
  }

  return <AddPhotosDevice onClick={addPhotos} disabled={isSaving} />;
}

MainView.propTypes = {
  ready: PropTypes.bool.isRequired,
  currentlyLoading: PropTypes.object,
  currentView: PropTypes.string.isRequired,
  hasPhotos: PropTypes.bool.isRequired,
  availableSizes: PropTypes.arrayOf(PrintSize).isRequired,
  sizesByFinish: PropTypes.array.isRequired,
  deliveryOption: DeliveryOption,
  editingDisabled: PropTypes.bool.isRequired,
  totalDuplicatesCount: PropTypes.number.isRequired,
  photosWithDuplicates: PropTypes.array.isRequired,
  addPhotos: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
};
